import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { IonicModule, ModalController } from "@ionic/angular";

import { SharedModule } from "app/shared/shared.module";
import { IncidentMedicationType, SearchedMedication } from "app/shared/types";
import { MedicationInputErrorComponent } from "../../../components/medication-input-error/medication-input-error.component";
import { SearchMedicationAutocompleteComponent } from "../../../components/search-medication-autocomplete/search-medication-autocomplete.component";

@Component({
	imports: [SharedModule, SearchMedicationAutocompleteComponent, IonicModule, MedicationInputErrorComponent],
	templateUrl: "./add-known-medication-popup.component.html",
	styleUrls: ["./add-known-medication-popup.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddKnownMedicationPopupComponent {
	private readonly modalCtrl = inject(ModalController);
	private readonly formBuilder = inject(FormBuilder);

	protected readonly form = this.formBuilder.group({
		// @ts-expect-error TS2769
		medication: this.formBuilder.control<SearchedMedication>(null, Validators.required),
		quantity: this.formBuilder.control<number | null>(null, [
			Validators.required,
			Validators.min(0.25),
			Validators.max(99),
		]),
	});

	onConfirm() {
		this.form.markAllAsTouched();

		if (this.form.valid) {
			const { medication, quantity } = this.form.value;

			this.modalCtrl.dismiss({
				medication: {
					type: IncidentMedicationType.KNOWN,
					...medication,
				},
				quantity,
			});
			this.form.reset();
		}
	}

	onCancel() {
		return this.modalCtrl.dismiss();
	}
}
